import React from "react";
import { createPortal } from "react-dom";

const loaderStyles = `
.logo-loader-container {
    position: relative;
    width: 90px;   /* smaller size */
    height: 80px;  /* smaller size */
}

.logo-loader {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: rotate 3s linear infinite, pulse 2.5s ease-in-out infinite;
    z-index: 10;
    position: relative;
}



/* Logo pulse */
@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.08); }
}

/* Rotate the logo */
@keyframes rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Rotate rings in opposite direction */
@keyframes ring-rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(-360deg); }
}
`;

export function ShowLoader() {
    const overlay = (
        <>
            <style>{loaderStyles}</style>
            {/* Portal + high z-index: loader inside <main> was below sticky header (nav z-50) due to stacking context */}
            <div
                className="fixed inset-0 flex items-center justify-center bg-[rgba(20,76,8,0.3)] backdrop-blur-md z-[10000]"
                aria-busy="true"
                aria-live="polite"
            >
                <div className="logo-loader-container">
                    <img
                        src="/img/logos/logo.png"
                        alt="Loading..."
                        className="logo-loader"
                    />
                </div>
            </div>
        </>
    );

    if (typeof document !== "undefined") {
        return createPortal(overlay, document.body);
    }
    return overlay;
}

export default ShowLoader;
